module.exports = __webpack_public_path__ + "static/img/4949_phase_function_Paper_PointsHejduk_Prediction.ebafcc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4949_phase_function_Paper_PointsHejduk_Prediction.png
// module id = a1Fr
// module chunks = 0